import React, { useRef, useState } from "react"
import { BsChevronDown, BsChevronUp, BsX } from "react-icons/bs"
import WithChildren from "../models/interfaces"
import { Col } from "./col"
import { Icon } from "./icon"
import { Row } from "./row"

export interface CollapsibleProps extends WithChildren {
    title: string
    collapsed?: boolean
    iconName?: string
    className?: string
    onRemove?: () => void
}

export function Collapsible({ title, collapsed = false, iconName, className, onRemove, children }: CollapsibleProps) {
    const divRef = useRef<HTMLDivElement>(null)
    const [forceRerenderToken, setForceRerenderToken] = useState(0)
    const [isCollapsed, setCollapsed] = useState<boolean>(collapsed)

    const toggleCollapse = () => {
        // because some code manipulates css classes via jquery
        // we can't trust the isCollapsed state and have to check the class list
        const wasShown = divRef.current?.classList.contains("show") ?? false
        setCollapsed(wasShown)
        // because isCollapsed might not necessarily change, we have to FORCE react to rerender the component
        setForceRerenderToken((old) => old + 1)
    }

    return (
        <Row key={forceRerenderToken}>
            <Col>
                <div className={`card ${className}`}>
                    <a onClick={toggleCollapse}>
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5>
                                {iconName ? <Icon name={iconName} /> : null}
                                {title}
                            </h5>
                            <div>
                                {onRemove && (
                                    <button className="btn btn-secondary me-3" type="button" onClick={onRemove} title={`${title} löschen`}>
                                        <BsX />
                                    </button>
                                )}
                                <span>{(!isCollapsed && <BsChevronDown />) || <BsChevronUp />}</span>
                            </div>
                        </div>
                    </a>
                    <div ref={divRef} className={`card-body collapse ${!isCollapsed ? "show" : ""}`}>
                        {children}
                    </div>
                </div>
            </Col>
        </Row>
    )
}
